export default __webpack_public_path__ + "static/media/PowertoSave_Thumbnail.fb98e138.jpg";